module.exports = __webpack_public_path__ + "img/project_coming_soon.7f6ca8f0.jpg";